import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO, { SITE_URL } from "@/components/site/SEO";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustCredibility from "@/components/site/TrustCredibility";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Markets from "@/components/site/Markets";
import Industries from "@/components/site/Industries";
import WhyUs from "@/components/site/WhyUs";
import Standards from "@/components/site/Standards";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Altin Link Danışmanlık Hizmetleri Ltd. Şti.",
  alternateName: "Altin Link",
  url: SITE_URL,
  logo: `${SITE_URL}/altin-logo.png`,
  description:
    "Türkiye-based commercial brokerage and business consulting company connecting manufacturers, suppliers, distributors, investors and corporate buyers across international markets.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Venezia Mall, J Block No: 01",
    addressLocality: "İstanbul",
    addressCountry: "TR",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+90-212-830-03-78",
    contactType: "customer service",
    email: "info@altin-link.com",
    availableLanguage: ["Turkish", "English", "Arabic"],
  },
  sameAs: ["https://www.linkedin.com/company/altin-link"],
};

export default function Landing() {
  const location = useLocation();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  useEffect(() => {
    const target = location.state && location.state.scrollTo;
    if (target) {
      // wait for sections to mount
      const t = setTimeout(() => {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 200);
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-altin-bg">
      <SEO
        description="Altin Link is a Türkiye-based commercial brokerage and business consulting company delivering strategic commercial partnerships across global markets. We connect manufacturers, suppliers, distributors, investors and corporate buyers across Türkiye, Europe, the Middle East and beyond."
        path="/"
        schema={orgSchema}
      />
      <Navbar />
      <main>
        <Hero
          onPrimary={() => scrollTo("contact")}
          onSecondary={() => scrollTo("contact")}
        />
        <TrustCredibility />
        <About />
        <Services />
        <Process />
        <Markets />
        <Industries />
        <WhyUs />
        <Standards />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
